import { FC, memo } from 'react'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  size?: number
  color?: 'primary' | 'gray'
}

const RegulationModuleBrand: FC<Props> = ({ color = 'primary', size = 12 }) => {
  const [primary200, primary300, primary400, primary500, primary600, primary700, primary900, white] = useToken('colors', [
    `${color}.200`,
    `${color}.300`,
    `${color}.400`,
    `${color}.500`,
    `${color}.600`,
    `${color}.700`,
    `${color}.900`,
    'white',
  ])

  const strokeColor900 = useColorModeValue(primary900, primary900)
  const strokenWidth = '40px'
  const strokenWidthSecondary = '20px'
  const fillColor200 = useColorModeValue(primary200, primary300)
  const fillColor400 = useColorModeValue(primary400, primary500)
  const fillColor600 = useColorModeValue(primary600, primary700)
  const fillBG = useColorModeValue(white, white)

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
        <g id="Regulação">
          <g id="background">
            <g id="group200">
              <path
                fill={fillColor200}
                opacity="0.25"
                d="M585.47,611.59C662.07,525.25,771,222.19,693.06,128,591,4.64,435,126.37,317.3,161.82-182.45,312.36,296,937.82,585.47,611.59Z"
              />
            </g>
            <g id="group400">
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M563.54,612.38c26.49,27.3,66.65,39.57,105.74,28,52.23-15.5,84.2-69.5,73.08-123.46-.07-.36-.15-.72-.23-1.08a103.23,103.23,0,0,1,.66-45.37,64.37,64.37,0,0,0-1-33.05c-9.79-33-44.29-52.5-77.17-43.7-12.74,3.4-37.27,21-55.82,34.81-12.51,9.33-24.33,13.34-39.07,8.13-16.76-5.92-47.9,1.6-61,20.34C484,492.1,487,504,495.13,546.58c3.65,19.12.55,44,38.37,44.93C543.76,591.76,556.34,605,563.54,612.38Z"
              />
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M246.83,153.51c-32.32-16.68-73.63-15.54-107.65,7-45.45,30-61.54,88.82-36.76,134.4.16.31.33.61.5.91a93,93,0,0,1,11.33,41.39,57.62,57.62,0,0,0,9.68,29.68c18,27,55.84,34.12,84.7,16.08,11.19-7,29.82-30.45,43.77-48.67C261.8,322,272,314.7,287.31,314.92c17.45.26,45-16.09,52.52-37.11,14.1-39.43,8.18-49.28-10.78-85.49-8.5-16.24-12.12-39.8-48.23-29.06C271,166.18,255.61,158.05,246.83,153.51Z"
              />
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M724.1,373.78c26.91-26.89,38.57-67.23,26.38-106.14-16.27-52-70.74-83.16-124.53-71.23l-1.08.24a103.22,103.22,0,0,1-45.37,0,64.25,64.25,0,0,0-33,1.51c-32.85,10.29-51.84,45.07-42.55,77.81,3.59,12.69,21.54,37,35.64,55.3,9.51,12.37,13.7,24.13,8.71,38.95-5.67,16.84,2.32,47.87,21.24,60.72,35.51,24.11,47.31,21,89.82,12.2,19.06-3.93,44-1.2,44.36-39C703.78,393.87,716.79,381.09,724.1,373.78Z"
              />
            </g>
            <g id="group600">
              <path
                fill={fillColor600}
                d="M360,732c-36.07-1.9-113-29-130-50-41.06-50.72-85.58-123.17-83.17-289.74C149.78,188.37,243.21,270.31,328,226c80.9-42.28,160.78-121,256-94,74,21,91,33,121,63,29,29,38.5,52.65,3.3,136.1C653.64,460.68,567.59,501.56,549.66,568.23,518.75,683.18,489,692,451,712,435.25,720.29,398,734,360,732Z"
              />
              <path
                fill={fillColor600}
                d="M73.94,424.24A40.61,40.61,0,0,0,84.2,472c14,12.28,31.73,27.89,36.76,28,23.33.56,4.94-95.54-6.11-107.25C102.31,379.41,84.51,401.73,73.94,424.24Z"
              />
              <path
                fill={fillColor600}
                d="M656,97c-8.44-14.36-43-14.26-47.33-1.52-3.48,14.44,22.83,24.81,38.37,31.32C654.63,126.19,666,114,656,97Z"
              />
              <path
                fill={fillColor600}
                d="M291.41,193.94C274.1,197,256.08,177.28,253,160s9.9-25.6,27.2-28.7,49.69,5.57,52.79,22.88S308.71,190.84,291.41,193.94Z"
              />
            </g>
          </g>
          <g>
            <path
              fill={fillBG}
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M337.05,245.34l-63.13,50.35h0a52.65,52.65,0,0,0-8.23,74,52,52,0,0,0,3.76,4.22l48.09,48.32h0a52.05,52.05,0,0,0,73.6.19,50.63,50.63,0,0,0,3.86-4.3l51-63.29h0A263.51,263.51,0,0,1,486.7,314.2l63.13-50.36h0a52.65,52.65,0,0,0,8.23-74,53.55,53.55,0,0,0-3.76-4.21l-48-48.29h0a52.12,52.12,0,0,0-77.47,4.1l-51,63.3h0A262.2,262.2,0,0,1,337.05,245.34Z"
            />
            <line
              fill="none"
              stroke={strokeColor900}
              strokeWidth={strokenWidthSecondary}
              strokeLinecap="round"
              strokeLinejoin="round"
              x1="416.18"
              y1="391.38"
              x2="301.7"
              y2="276.61"
            />
            <path
              fill={fillBG}
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M193.81,638.42l15.64-46.82h0a57.39,57.39,0,0,1,54.32-39.26H376a57.4,57.4,0,0,1,54.52,39.26L446,638.42"
            />
            <line
              fill="none"
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              x1="167.99"
              y1="638.42"
              x2="471.84"
              y2="638.42"
            />
            <line
              fill="none"
              stroke={strokeColor900}
              strokeWidth={strokenWidthSecondary}
              strokeLinecap="round"
              strokeLinejoin="round"
              x1="408.72"
              y1="169.3"
              x2="523.49"
              y2="284.07"
            />
            <path
              fill={fillBG}
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M494.39,308.09l170,143.83h0a57,57,0,0,1-73.8,86.85,57.87,57.87,0,0,1-5.22-5L435.17,368.34"
            />
          </g>
        </g>
      </svg>
    </Box>
  )
}

export default memo(RegulationModuleBrand)
